export default "__VITE_ASSET__BuGA4zEj__"